import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __ANPR_PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

interface TypeVoidMarriageListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (typeVoidMarriage?: string) => void;
  error?: boolean;
  label?: string;
  required?: boolean;
  id?: string;
}

type Key = {
  codice: string;
};

interface TypeVoidMarriage {
  key: Key;
  descrizione: string;
}

const TypeVoidMarriageListComponent = ({
  disabled,
  onChange,
  value,
  error,
  required,
  label = 'Tipo cessazione matrimonio',
  id = 'typeVoidMarriage',
}: TypeVoidMarriageListComponentProps): React.ReactElement => {
  const [typeVoidMarriage] = useHttpFetch<HttpResponseList<TypeVoidMarriage>, Array<ItemVM>>(
    `${__ANPR_PERSON_API_URL__}/tipo-cessazione-matrimonio`,
    {
      onBootstrap: true,
      initialData: [],
      transformer: (response: AxiosResponse<HttpResponseList<TypeVoidMarriage>>) => {
        const { data } = response;

        return data?.payload.list.map((item) => ({
          id: item.key.codice,
          value: item.descrizione,
        })) as Array<ItemVM>;
      },
    }
  );

  const list = typeVoidMarriage.data as Array<ItemVM>;

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list?.map((item: ItemVM) => (
          <MenuItem key={item?.id} value={item?.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeVoidMarriageListComponent.displayName = 'Type void marriage List component';

const TypeVoidMarriageList = memo(TypeVoidMarriageListComponent);

export default TypeVoidMarriageList as typeof TypeVoidMarriageListComponent;
